import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { callApi } from "../../../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import ErrorMessage from "../../../../../components/comman/ErrorMessage";
import { errorTypes } from "../../../../../utility/InputValidation";

export default function EmployeeAdvanceDetails({ locationData, pageStatesMain, setPageStatesMain }) {
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (locationData) {
      reset({
        uanNumber: locationData?.userdetail?.uanNumber || "",
        aadharNumber: locationData?.userdetail?.aadharNumber || "",
        esicNumber: locationData?.userdetail?.esicNumber || "",
        drivingLicenseNumber: locationData?.userdetail?.drivingLicenseNumber || "",
        insuranceNumber: locationData?.userdetail?.insuranceNumber || "",
        panNumber: locationData?.userdetail?.panNumber || "",
        pfNumber: locationData?.userdetail?.pfNumber || "",
      })
    }
  }, [])

  const onSubmit = (data) => {
    // console.log("submitData>>>>>>>>>>",data);
    const formData = new FormData();
    formData.append("uanNumber", data?.uanNumber);
    formData.append("aadharNumber", data?.aadharNumber);
    formData.append("esicNumber", data?.esicNumber);
    formData.append("drivingLicenseNumber", data?.drivingLicenseNumber);
    formData.append("insuranceNumber", data?.insuranceNumber);
    formData.append("panNumber", data?.panNumber);
    formData.append("pfNumber", data?.pfNumber);
    formData.append("activeTab", "Advance Details");

    const options = {
      method: "POST",
      form_data: formData,
    };
    let API = apiUrl?.add_employee + `?userId=${locationData?.id ? locationData?.id : pageStatesMain?.Id_onCreateEmp}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        setPageStatesMain((prev) => ({
          ...prev,
          activeTab: 4,
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-12">
          <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
            Advance Details
          </h4>
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <div className="form-group mb-3">
            <label htmlFor="aadharNum" className="form-label">
              Aadhar Number
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Aadhar Number"
              id="aadharNum"
              aria-describedby="emailHelp"
              maxLength={12}
              {...register("aadharNumber", {
                ...errorTypes.required("Aadhar number"),
                ...errorTypes.aadhaar,
              })}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\s/g, '').replace(/[^0-9]/g, "")
              }}
            />
            <ErrorMessage message={errors?.aadharNumber?.message} />
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <div className="form-group mb-3">
            <label htmlFor="panNum" className="form-label">
              PAN Number <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="PAN Number"
              id="panNum"
              {...register("panNumber", {
                ...errorTypes.required("Pan card number"),
                ...errorTypes.pan,
              })}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\s/g, '').toUpperCase().slice(0, 10); // Convert to uppercase and limit to 10 characters
              }}
            />

            <ErrorMessage message={errors?.panNumber?.message} />
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <div className="form-group mb-3">
            <label htmlFor="UANno" className="form-label">
              UAN no.
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="UAN no."
              id="UANno"
              aria-describedby="emailHelp"
              {...register("uanNumber", {
                ...errorTypes.uanNumber,
              })}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\s/g, '').replace(/[^0-9]/g, '').slice(0, 12);
              }}
            />
            <ErrorMessage message={errors?.uanNumber?.message} />
          </div>
        </div>

        <div className="col-12 col-md-6 col-lg-4">
          <div className="form-group mb-3">
            <label htmlFor="ESICNum" className="form-label">
              ESIC Number
            </label>
            <input
              type="text"   // <-- Change to text for better input control
              className="form-control"
              placeholder="Enter ESIC Number"
              id="ESICNum"
              {...register("esicNumber", {
                ...errorTypes.esic,
              })}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\s/g, '').replace(/[^0-9]/g, '').slice(0, 17);
              }}
            />
            <ErrorMessage message={errors?.esicNumber?.message} />
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <div className="form-group mb-3">
            <label htmlFor="PFnum" className="form-label">
              PF Number
            </label>
            <input
              type="number"
              onWheel={(e) => e.target.blur()}
              className="form-control"
              placeholder="PF Number"
              id="PFnum"
              maxLength={25}
              {...register("pfNumber", {
                // required: "This field is Required",
              })}
            />
            <ErrorMessage message={errors?.pfNumber?.message} />
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <div className="form-group mb-3">
            <label htmlFor="InsuranceNum" className="form-label">
              Insurance Number
            </label>
            <input
              type="number"
              onWheel={(e) => e.target.blur()}
              className="form-control"
              placeholder="Enter Insurance Number"
              id="InsuranceNum"
              maxLength={25}
              {...register("insuranceNumber", {
                // required: "This field is Required",
              })}
            />
            <ErrorMessage message={errors?.insuranceNumber?.message} />
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <div className="form-group mb-3">
            <label htmlFor="Drive" className="form-label">
              Driving License No.
            </label>
            <input
              type="text"
              className="form-control"
              id="Drive"
              placeholder="Driving License No."
              {...register("drivingLicenseNumber", {
                ...errorTypes.drivingLicense
              })}
              onInput={(e) => {
                e.target.value = e.target.value
                  .toUpperCase()               // Force uppercase
                  .replace(/[^A-Z0-9]/g, '')    // Remove spaces, special characters
                  .slice(0, 17);                // Limit max 17 characters
              }}
            />

            <ErrorMessage message={errors?.drivingLicenseNumber?.message} />
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-end">
        <button className="btn btn-primary px-4" type="submit">
          {isLoading ? <Spinner /> : "Save and Continue"}
        </button>
      </div>
    </form>
  );
}
